import portfolio from "../assets/portfolio.png"
import music from "../assets/music.png"
import tours from "../assets/tours.png"
import keanu from "../assets/keanu.png"
import kanye from "../assets/kanye.png"
import dragon from "../assets/dragon.png"
import kumara from "../assets/kumara.png"
import karakol from "../assets/karakol.png"
import apple from "../assets/apple.png"

export const projects = [
  {
    title: 'Portfolio',
    img: portfolio,
    link: 'https://baitemir.netlify.app/',
    github: 'https://github.com/BaitemirAsanbaev/portfolio'
  },
  {
    title: 'Music maker',
    img: music,
    link: 'https://melody-maker.netlify.app/',
    github: 'https://github.com/BaitemirAsanbaev/music-maker'
  },
  {
    title: 'Kyrgyz Tours',
    img: tours,
    link: 'https://kyrgyz-tour.netlify.app/',
    github: 'https://github.com/BaitemirAsanbaev/kyrgyz-tours'
  },
  {
    title: 'Keanu Weather',
    img: keanu,
    link: 'https://keanu-weather.netlify.app/',
    github: 'https://github.com/BaitemirAsanbaev/keanu-weather'
  },
  {
    title: 'Kanye Western',
    img: kanye,
    link: 'https://kanye-western.netlify.app/',
    github: 'https://github.com/BaitemirAsanbaev/kanye-weatern'
  },

  {
    title: 'Dragon',
    img: dragon,
    link: 'https://dragon-animation.netlify.app/',
    github: 'https://github.com/BaitemirAsanbaev/dragon-animation'
  },
  {
    title: 'Altyn Kumara',
    img: kumara,
    link: 'https://altyn-kumara.netlify.app/',
    github: 'https://github.com/BaitemirAsanbaev/altyn-kumara'
  },
  {
    title: 'Karakol tech',
    img: karakol,
    link: 'https://karakol-tech.netlify.app/',
    github: 'https://github.com/BaitemirAsanbaev/karakol-tech'
  },
  {
    title: 'Apple copy',
    img: apple,
    link: 'https://apple-layout.netlify.app/',
    github: 'https://github.com/BaitemirAsanbaev/apple-copy'
  },

]